import { useMutation, useQueryClient } from "@tanstack/react-query"
import { apiFetch } from "../../../framework/api"
import { useAuthToken } from "../../../hooks/useAuthToken"

export function useDeletePromoCode() {
  const token = useAuthToken()
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (code: string) => {
      await apiFetch("/admin/promo-codes/delete", {
        token,
        method: "POST",
        body: JSON.stringify({ Code: code }),
      })
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["promoCodes"] })
    },
  })
}
